'use client'

import {createGlobalStyle} from 'styled-components'

import theme, {media} from '@/src/config/theme'

import {AntdStyled} from './antd'
import {OtherStyles} from './other'
import {ToastifyVariables} from './toastify-variables'
import {UtilStyles} from './util'
import {YaMapStyles} from './ya-map'
import {SnippetsStyles} from './snippets'

export const GlobalStyles = createGlobalStyle`
  ${AntdStyled}
  ${UtilStyles}
  ${YaMapStyles}
  ${ToastifyVariables}
  ${OtherStyles}
  ${SnippetsStyles}
  
  :root {
    --toastify-color-progress-dark: #fff;
  }

  ::-moz-selection {
    background: ${theme.colors.primary};
    color: ${theme.colors.text};
    text-shadow: none;
  }

  ::selection {
    background: ${theme.colors.primary};
    color: ${theme.colors.text};
    text-shadow: none;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    min-height: 100vh;

    font-display: swap;
    font-size: 16px;

    letter-spacing: 0.03em;

    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }
  
  button,input {
    font-size: inherit;
    font-display: inherit;

    letter-spacing: inherit;

    -webkit-text-size-adjust: inherit;
    -ms-text-size-adjust: inherit;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: ${theme.colors.bgDark};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${theme.colors.scrollColor};

    &:hover {
      background-color: ${theme.colors.scrollHoverColor};
    }
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.scrollBg};
  }

  h1, h2, h3, h4 {
    font-weight: 450;
  }

  strong, b {
    font-weight: 500;
  }

  h1, h2 {
    line-height: 1;
    display: inline-block;
    color: ${theme.colors.text};

    [data-dark="true"] & {
      color: ${theme.colors.textDark};
    }

    [ignore-dark="true"] & {
      color: ${theme.colors.text};
    }
  }

  a {
    [data-dark="true"] & > span {
      color: ${theme.colors.textDark};

      &:hover {
        color: ${theme.colors.primary};
      }
    }

    [ignore-dark="true"] & > span {
      color: ${theme.colors.text};
    }
  }

  h1 {
    font-size: 1.125rem;

    @media ${media.md} {
      font-size: 1.75rem;
    }

    @media ${media.lg} {
      font-size: 2rem;
    }
  }

  h2 {
    font-size: 1.1rem;

    @media ${media.md} {
      font-size: 1.25rem;
    }
  }

  h2 {
    border-bottom: ${theme.colors.titleBorder};
  }

  [data-dark="true"] h2 {
    border-bottom: ${theme.colors.titleBorderDark};
  }

  [ignore-dark="true"] h2 {
    border-bottom: ${theme.colors.titleBorder};
  }

  [data-dark="true"] {
    color: ${theme.colors.textDark};
  }

  [ignore-dark="true"],
  [ignore-dark="true"] * {
    color: ${theme.colors.text};
  }

  img {
    max-width: 100%;
    object-fit: contain;
  }

  :root {
    --toastify-font-family: inherit;
  }

  .spinner {
    animation: 1s spin infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  * {
    transition: color, background-color, background 0.3s ease;
  }

  .no-select,
  .no-select * {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none;   /* Chrome, Safari, Opera */
    -khtml-user-select: none;    /* Konqueror */
    -moz-user-select: none;      /* Firefox */
    -ms-user-select: none;       /* Internet Explorer/Edge */
    user-select: none;           /* Стандартный синтаксис */
  }
`
